import http from '../httpService';

class StateService {
    public async getStates(countryId: number) {
      let result = await http.get('api/v1/utility/states?countryId=' + countryId);
      return result.data;
    }
}

export default new StateService();